module.exports = __webpack_public_path__ + "static/media/illustration-working.5029d049.svg";